import React, { useState, useEffect } from 'react'
import CircularLoader from '../../common/CircularLoader';
import VideoPlayer from "../../media/VideoPlayer";
import WidgetPlayer from "../../media/WidgetPlayer";
import ScorcherPlayer from "../../media/ScorcherPlayer";
import DesmosPlayer from "../../media/DesmosPlayer";
import AlgebraKitBlock from "../../common/AlgebraKitBlock";

const MediaActivity = ({step, stepActivity}) => {
    if (!step || !stepActivity) {
        return <CircularLoader />;
    }

    if(step.mediaType == 'VIDEO') {
        return <VideoPlayer mediaId={stepActivity.mediaId} conceptId={step.conceptId}/>;
    }

    if(step.mediaType == 'WIDGET') {
        return <WidgetPlayer mediaId={stepActivity.mediaId} conceptId={step.conceptId}/>;
    }

    if(step.mediaType == 'DESMOS') {
        return <DesmosPlayer mediaId={stepActivity.mediaId} conceptId={step.conceptId}/>;
    }

    if(step.mediaType == 'SCORCHER') {
        return <ScorcherPlayer stepId={step.stepId} scorcherType="PATHWAY"/>;
    }

    if(step.mediaType == 'ALGEBRA_KIT') {
        return <AlgebraKitBlock mediaId={stepActivity.mediaId} conceptId={step.conceptId}/>;
    }

    return null;
}

export default MediaActivity;
